/**
 * desktop-only-notice.tsx — Thay nội dung trang khi mở một chức năng CHỈ DÙNG TRÊN MÁY TÍNH ở điện thoại
 * (gõ / lưu đường dẫn, bấm từ liên kết trong trang…). Xem lib/mobile-scope.ts.
 * Kiểu thẻ trống của Lark Mobile: biểu tượng, lời giải thích, nút chính "Gửi liên kết sang máy tính" (bảng chia sẻ, hoặc sao chép) và nút về Hộp thư.
 */
import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { MonitorSmartphone, Send } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { DesktopOnlyArea } from '@/lib/mobile-scope'
import { SHARE_TOAST, shareLink } from '@/lib/share-link'

export function DesktopOnlyNotice({ area }: { area: DesktopOnlyArea }) {
  const { t } = useTranslation('sharedMisc')
  // Bảng chia sẻ của điện thoại (gửi cho chính mình qua Zalo / email…); không có thì sao chép.
  const sendLink = async () => {
    const r = SHARE_TOAST[await shareLink(window.location.href, area.label)]
    if (r.type) toast[r.type](r.text)
  }
  return (
    <main className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 overflow-y-auto px-8 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-3xl bg-primary/10 text-primary">
        <MonitorSmartphone className="h-10 w-10" strokeWidth={1.6} />
      </div>
      <div className="space-y-1.5">
        <h1 className="text-lg font-semibold">{t('desktopOnlyNotice.title')}</h1>
        <p className="text-sm text-muted-foreground">
          <Trans t={t} i18nKey="desktopOnlyNotice.description" values={{ area: area.label }} components={{ b: <span className="font-medium text-foreground" /> }} />
        </p>
      </div>
      <div className="flex w-full max-w-xs flex-col gap-2">
        <Button onClick={() => void sendLink()} className="h-11">
          <Send className="h-4 w-4" /> {t('desktopOnlyNotice.sendLink')}
        </Button>
        <Button asChild variant="outline" className="h-11">
          <Link to="/conversations">{t('desktopOnlyNotice.backToInbox')}</Link>
        </Button>
      </div>
    </main>
  )
}
